import React, { useEffect, useState } from "react";
import { money } from "../utilities/currency";
import { Header } from "../components/ui/header";
import axios from "axios";
import { Footer } from "../components/ui/footer";
import PaymentModal from "../components/ui/paymentmodal";
import { current } from "@reduxjs/toolkit";
import { getAgentDisplayPicUrl } from "../utilities/conversions";
import Swal from "sweetalert2";
import { RootState } from "../state/store";
import { useSelector } from "react-redux";
type EventDetailPageProps = {
    event: any,
    onBack: () => void,
    currentUser: any,
    baseUrl: string,
    onLoginSuccess: (token: string, role: string, name: string) => void,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
// export default function EventDetailPage({ event, onBack }) {
export default function EventDetailPage({ event, onBack, currentUser, baseUrl, onLoginSuccess }: EventDetailPageProps) {
    // TEMP: Dummy e so the page is visible in preview
    const dummyEvent = {
        title: "Digital Rådgivning – Introduksjonskurs",
        description:
            "Et komplett introduksjonsforedrag om digital rådgivning, livestreams og hvordan Chamcore-plattformen muliggjør fjernlevering av tjenester i høy kvalitet.",
        price: 0,
        live: true,
        uploaded_file:
            "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1200&q=80",
    };

    const e = event || dummyEvent;
    const client = useSelector((state: RootState) => state.client.client);
    const [open, setOpen] = useState(false);
    const [showCountryInputs, setShowCountryInputs] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [countryCode, setCountryCode] = useState({ code: "+47", country: "Norge", flag: "🇳🇴" });
    const [paymentMethod, setPaymentMethod] = useState<"vipps" | "stripe">("vipps");
    const [vippsAuthenticate, setVippsAuthenticate] = useState(false);
    const [stripeAuthenticate, setStripeAuthenticate] = useState(false);

    const handleJoinClick = () => {
        currentUser?.role === "customer" ? setShowCountryInputs(false) : setShowCountryInputs(true);
        setOpen(true);
    }

    useEffect(() => {
        const channel = new BroadcastChannel("chamcore-broadcast-approve-payment");
        channel.onmessage = (event) => {
            if (event.data?.type === "BROADCAST_CARD_PAYMENT_APPROVED") {
                setOpen(false);
                Swal.fire({
                    icon: "success",
                    title: "Vellykket betaling",
                    text: "Betalingen for timebestillingen er vellykket.",
                    showConfirmButton: true,
                });
                setStripeAuthenticate(false);
                if (typeof onLoginSuccess === "function") {
                    onLoginSuccess(event.data?.token, event.data?.role, event.data?.name);
                }
            }
        };
        return () => channel.close();
    }, []);

    const handleSubmit = async (a: any) => {
        a.preventDefault();
        console.log('submit broadcast pay');
        let formData = new FormData();
        if (currentUser?.role === "customer") {
            formData.append("token", currentUser?.token);
        }
        formData.append("agent_id", e.agent.uid);
        formData.append("phone", phoneNumber);
        formData.append("country_code", countryCode.code);
        formData.append("broadcast_id", e.broadcast_id);
        formData.append("payment_method", paymentMethod);
        formData.append("client_uid", client?.uid);

        try {
            if (paymentMethod === "vipps") {
                setVippsAuthenticate(true);
            } else {
                setStripeAuthenticate(true);
            }
            const response = await axios.post(baseUrl + '/bookBroadcast', formData);

            if (response.data.status === "OK") {
                if(paymentMethod === "stripe"){
                    // Redirect to Stripe Checkout
                    window.open(response.data.redirect_url, "_blank");
                    return;
                }

                if (typeof onLoginSuccess === "function") {
                    onLoginSuccess(response.data?.token, response.data?.role, response.data?.name);
                }

                Swal.fire({
                    title: 'Success',
                    icon: "success",
                    text: response.data.data,
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    icon: "error",
                    text: response.data.data,
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            if (paymentMethod === "vipps") {
                setVippsAuthenticate(false);
            } else {
                setStripeAuthenticate(false);
            }
        }
    }

    return (
        <div className={"bg-white text-gray-900"}>

            <div className="w-full min-h-screen bg-gradient-to-b from-white to-slate-50 py-12 px-6 animate-fadeIn">
                <button
                    onClick={onBack}
                    className="mb-6 text-blue-600 hover:text-blue-800 text-sm font-medium"
                >
                    ← Tilbake
                </button>
                <div className="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl shadow-xl rounded-3xl overflow-hidden border border-white/20">
                    <div className="relative h-80 w-full">
                        <img src={e.uploaded_file} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/70" />
                        {e.status === "live" && (
                            <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md animate-pulse">
                                LIVE NÅ
                            </div>
                        )}
                        <h1 className="absolute bottom-4 left-6 text-4xl font-bold text-white drop-shadow-lg">
                            {e.title}
                        </h1>
                    </div>

                    <div className="p-10">
                        {/* Date & Time */}
                        <div className="mb-8">
                            <p className="text-slate-900 font-semibold text-lg">Dato & tid</p>
                            <p className="text-slate-600 text-md">{e.formatted_start_date_time}</p>
                        </div>

                        <p className="text-slate-700 mb-6 text-lg leading-relaxed">
                            {e.description}
                        </p>

                        <div className="flex items-center gap-4 mb-10">
                            <img
                                src={getAgentDisplayPicUrl(e.agent.display_pic, baseUrl)}
                                alt={e.agent.name}
                                className="w-20 h-20 rounded-full object-cover"
                            />
                            <div>
                                <p className="font-semibold text-slate-900 text-lg">{e.agent.name}</p>
                                <p className="text-sm text-slate-600">Sertifisert</p>
                            </div>
                        </div>

                        <div className="flex justify-between items-center">
                            <span className="text-2xl font-semibold text-purple-700">
                                {e.broadcast_price === 0 ? "Gratis" : `${e.broadcast_price} kr`}
                            </span>
                            <button onClick={handleJoinClick} className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-purple-600 text-white text-lg font-medium hover:bg-purple-700 transition">
                                {e.broadcast_price === 0 ? "Delta gratis" : "Kjøp tilgang"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <PaymentModal
                isOpen={open}
                onClose={() => setOpen(false)}
                eventName={e.title}
                startDateTime={e.formatted_start_date_time}
                broadcastPrice={e.broadcast_price}
                onSubmit={handleSubmit}
                showCountryInputs={showCountryInputs} // set false for logged-in user
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                countryCode={countryCode}
                setCountryCode={setCountryCode}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                vippsAuthenticate={vippsAuthenticate}
                stripeAuthenticate={stripeAuthenticate}
            />
        </div>
    );
}
